import { render, staticRenderFns } from "./VmLoadingComponent.vue?vue&type=template&id=0206dd85&"
import script from "./VmLoadingComponent.vue?vue&type=script&lang=js&"
export * from "./VmLoadingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports